import { Outlet, Route, Routes } from "react-router-dom";
import { lazy } from "react";
import { PublicLayout } from "../components/layouts/PublicLayout";
const HomeRoute = lazy(() => import("./Home"));
const FAQRoute = lazy(() => import("./public/FAQ").then((m) => ({ default: m.FAQRoute })));
const PaymentsRoute = lazy(() => import("./public/Payments").then((m) => ({ default: m.PaymentsRoute })));
const ProgrammesRoute = lazy(() => import("./public/Programmes").then((m) => ({ default: m.ProgrammesRoute })));
const QualificationTypesRoute = lazy(() => import("./public/QualificationTypes").then((m) => ({ default: m.QualificationTypesRoute })));
const ProgrammeChangesRoute = lazy(() => import("./public/ProgrammeChanges").then((m) => ({ default: m.ProgrammeChangesRoute })));
const ImportantNoticesRoute = lazy(() => import("./public/ImportantNotices").then((m) => ({ default: m.ImportantNoticesRoute })));
const CareerGuidanceRoute = lazy(() => import("./public/CareerGuidance").then((m) => ({ default: m.CareerGuidanceRoute })));
const DecidingOnYourCareer = lazy(() => import("../features/public/career-guidance/deciding-on-your-career"));
const PayingForYourStudies = lazy(() => import("../features/public/career-guidance/paying-for-your-studies"));
const StudyBudgetCalculator = lazy(() => import("../features/public/career-guidance/study-budget-calculator"));
const WorkingPersonality = lazy(() => import("../features/public/career-guidance/working-personality"));
const SelfAssessmentQuiz = lazy(() => import("../features/public/career-guidance/self-assessment-quiz"));
const AnimalCareerDirection = lazy(() => import("../features/public/career-guidance/animal-career-direction"));
const RelatedLearningFields = lazy(() => import("../features/public/career-guidance/related-learning-fields"));
const LoginRoute = lazy(() => import("./Login").then((m) => ({ default: m.LoginRoute })));
const ForgotPasswordRoute = lazy(() => import("./ForgotPassword").then((m) => ({ default: m.ForgotPasswordRoute })));
const MemberInstitutionsRoute = lazy(() => import("./public/MemberInstitutions").then((m) => ({ default: m.MemberInstitutionsRoute })));
const MemberInstitutions = lazy(() => import("../features/public/member-institutions"));
const DU = lazy(() => import("../features/public/member-institutions/du"));
const MN = lazy(() => import("../features/public/member-institutions/mn"));
const KN = lazy(() => import("../features/public/member-institutions/kn"));
const UZ = lazy(() => import("../features/public/member-institutions/uz"));
const PC = lazy(() => import("../features/public/member-institutions/pc"));
const AAASchoolOfAdvertising = lazy(() => import("../features/public/member-institutions/components/aaa-school-of-advertising"));
const BereaCollegeOfTechnology = lazy(() => import("../features/public/member-institutions/components/berea-college-of-technology"));
const BereaTechnicalCollege = lazy(() => import("../features/public/member-institutions/components/berea-technical-college"));
const CentralTechnicalCollege = lazy(() => import("../features/public/member-institutions/components/central-technical-college"));
const Eduvos = lazy(() => import("../features/public/member-institutions/components/eduvos"));
const IStudentAcademy = lazy(() => import("../features/public/member-institutions/components/istudent-academy"));
const Mancosa = lazy(() => import("../features/public/member-institutions/components/mancosa"));
const PaxCollege = lazy(() => import("../features/public/member-institutions/components/pax-college"));
const RegentBusinessSchool = lazy(() => import("../features/public/member-institutions/components/regent-business-school"));
const RichfieldGraduateInstituteOfTechnology = lazy(() => import("../features/public/member-institutions/components/richfield-graduate-institute-of-technology"));
const StadioInstituteForHigherEducation = lazy(() => import("../features/public/member-institutions/components/stadio-institute-for-higher-education"));
const AboutRoute = lazy(() => import("./public/About").then((m) => ({ default: m.AboutRoute })));
const AboutCAO = lazy(() => import("../features/public/about-cao/about"));
const Mission = lazy(() => import("../features/public/about-cao/mission"));
const Team = lazy(() => import("../features/public/about-cao/team"));
const Partners = lazy(() => import("../features/public/about-cao/partners"));
const Apply = lazy(() => import("../features/public/apply"));
const ApplyRoute = lazy(() => import("./public/apply/Apply").then((m) => ({ default: m.ApplyRoute })));
const HowToRoute = lazy(() => import("./public/apply/HowTo").then((m) => ({ default: m.HowToRoute })));
const RegistrationRoute = lazy(() => import("./public/apply/Registration").then((m) => ({ default: m.RegistrationRoute })));
const SuccessRoute = lazy(() => import("./public/apply/Success").then((m) => ({ default: m.SuccessRoute })));
const InternationApplicantsRoute = lazy(() => import("./public/apply/InternationApplicants").then((m) => ({ default: m.InternationApplicantsRoute })));
const AcronymnsAndAbbreviationsRoute = lazy(() => import("./public/apply/Acronyms").then((m) => ({ default: m.AcronymnsAndAbbreviationsRoute })));
const TermsAndConditionsRoute = lazy(() => import("./public/apply/Terms").then((m) => ({ default: m.TermsAndConditionsRoute })));
const CheckMyApplicationRoute = lazy(() => import("./public/apply/CheckMyApplication").then((m) => ({ default: m.CheckMyApplicationRoute })));
const ContactUs = lazy(() => import("../features/public/contact-us"));
const NotFound = lazy(() => import("./NotFound"));
const ReportError = lazy(() => import("@/features/report-error"));

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<HomeRoute />} />
        <Route path="faq" element={<FAQRoute />} />
        <Route path="payments" element={<PaymentsRoute />} />
        <Route path="programmes" element={<ProgrammesRoute />} />
        <Route
          path="qualification-types"
          element={<QualificationTypesRoute />}
        />
        <Route
          path="programme-changes"
          element={<ProgrammeChangesRoute />}
        />
        <Route
          path="important-notices"
          element={<ImportantNoticesRoute />}
        />
        <Route path="career-guidance" element={<CareerGuidanceRoute />}>
          <Route index element={<DecidingOnYourCareer />} />
          <Route
            path="paying-for-your-studies"
            element={<PayingForYourStudies />}
          />
          <Route
            path="study-budget-calculator"
            element={<StudyBudgetCalculator />}
          />
          <Route path="working-personality" element={<WorkingPersonality />} />
          <Route
            path="self-assessment-quiz"
            element={<SelfAssessmentQuiz />}
          />
          <Route
            path="animal-career-direction"
            element={<AnimalCareerDirection />}
          />
          <Route
            path="related-learning-fields"
            element={<RelatedLearningFields />}
          />
        </Route>
        <Route path="login" element={<LoginRoute />} />
        <Route path="forgot-password" element={<ForgotPasswordRoute />} />
        <Route path="report-error" element={<ReportError />} />

        <Route
          path="member-institutions"
          element={<MemberInstitutionsRoute />}
        />
        <Route path="member-institutions" element={<MemberInstitutions />}>
          <Route path="DU" element={<DU />} />
          <Route path="MN" element={<MN />} />
          <Route path="KN" element={<KN />} />
          <Route path="UZ" element={<UZ />} />
          <Route path="PC" element={<Outlet />}>
            <Route index element={<PC />} />
            <Route
              path="aaa-school-of-advertising"
              element={<AAASchoolOfAdvertising />}
            />
            <Route
              path="berea-college-of-technology"
              element={<BereaCollegeOfTechnology />}
            />
            <Route
              path="berea-technical-college"
              element={<BereaTechnicalCollege />}
            />
            <Route
              path="central-technical-college"
              element={<CentralTechnicalCollege />}
            />
            <Route path="eduvos" element={<Eduvos />} />
            <Route path="istudent-academy" element={<IStudentAcademy />} />
            <Route path="mancosa" element={<Mancosa />} />
            <Route path="pax-college" element={<PaxCollege />} />
            <Route
              path="regent-business-school"
              element={<RegentBusinessSchool />}
            />
            <Route
              path="richfield-graduate-institute-of-technology"
              element={<RichfieldGraduateInstituteOfTechnology />}
            />
            <Route
              path="stadio-institute-for-higher-education"
              element={<StadioInstituteForHigherEducation />}
            />
          </Route>
        </Route>
        <Route path="about" element={<AboutRoute />}>
          <Route index element={<AboutCAO />} />
          <Route path="mission" element={<Mission />} />
          <Route path="team" element={<Team />} />
          <Route path="partners" element={<Partners />} />
        </Route>
        <Route path="apply" element={<Apply />}>
          <Route index element={<ApplyRoute />} />
          <Route path="how-to-apply" element={<HowToRoute />} />
          <Route path="apply-now" element={<ApplyRoute />} />
          <Route path="registration" element={<RegistrationRoute />} />
          <Route path="success" element={<SuccessRoute />} />
          <Route
            path="international-applicants"
            element={<InternationApplicantsRoute />}
          />
          <Route
            path="acronyms-and-abbreviations"
            element={<AcronymnsAndAbbreviationsRoute />}
          />
          <Route
            path="terms-and-conditions"
            element={<TermsAndConditionsRoute />}
          />
          <Route
            path="check-my-application"
            element={<CheckMyApplicationRoute />}
          />
        </Route>
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};
